import React, { Component } from "react";
import { Link } from "react-router-dom";

// Layout
import Header from "../layout/header/header1";

// Images
import bannerImg from "../../images/banner/banner3.jpg";
import news91Img from "../../images/news/news9_1.jpg";
import news92Img from "../../images/news/news9_2.jpg";
import news93Img from "../../images/news/news9_3.jpg";
import news94Img from "../../images/news/news9_4.jpg";
import news95Img from "../../images/news/news9_5.jpg";
import news96Img from "../../images/news/news9_6.jpg";
import news97Img from "../../images/news/news9_7.jpg";
import video1 from "../../videos/lego1.mp4";
import video2 from "../../videos/lego2.mp4";

import { withTranslation } from "react-i18next";


class news9 extends Component {
	componentDidMount() {

	}

	componentWillMount() {
		const { t } = this.props;
		document.getElementById('title').innerText = t("News9_Title");
	}

	componentWillUnmount() {
		const { t } = this.props;
		document.getElementById('title').innerText = t("Home_Title");
	}

	render() {
		const { t } = this.props;
		return (
			<>
				<Header />

				<div className="page-content">
					<div
						className="page-banner ovbl-dark"
						style={{ backgroundImage: "url(" + bannerImg + ")" }}
					>
						<div className="container">
							<div className="page-banner-entry">
								<h1 className="text-white">{t("News9_Title")}</h1>
							</div>
						</div>
					</div>
					<div className="breadcrumb-row">
						<div className="container">
							<ul className="list-inline">
								<li>
									<Link to="/">{t("News9_LinkHome")}</Link>
								</li>
								<li>{t("News9_LinkCourses")}</li>
							</ul>
						</div>
					</div>
					<div className="content-block">
						<div className="section-area section-sp1">
							<div className="container">
								<div className="row d-flex flex-row-reverse">
									<div className="col-xl-9 col-lg-8 col-md-12 col-sm-12">
										<div className="courses-post">
											<h1>{t("News9_Content_H")}</h1>
											<p>{t("News9_Content_P1")}</p>
											<img src={news91Img} alt="" />
											<p>{t("News9_Content_P2")}</p>
											<img src={news92Img} alt="" />
											<p>{t("News9_Content_P3")}</p>
											<img src={news93Img} alt="" />
											<p>{t("News9_Content_P5")}</p>
											<img src={news94Img} alt="" />
											<p>{t("News9_Content_P6")}</p>
											<img src={news95Img} alt="" />
											<p>{t("News9_Content_P8")}</p>
											<img src={news96Img} alt="" />
											<p>{t("News9_Content_P9")}</p>
											<img src={news97Img} alt="" />
											<hr />
											<video style={{ width: '100%', height:'auto' }} controls>
												<source src={video1} type="video/mp4" alt="Lego Video" />
											</video>
											<hr />
											<video style={{ width: '100%', height:'auto' }} controls>
												<source src={video2} type="video/mp4" alt="Lego Video" />
											</video>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</>
		);
	}
}

export default news9 = withTranslation()(news9);
